import { takeLatest, call, put } from 'redux-saga/effects'
import list from 'api/integrations/list'
import * as fromActions from '../../actions/general.action'

function* getIntegrationsEffectSaga() {
  try {
    const data = yield call(list)
    yield put(fromActions.Actions.getIntegrationsListSuccess(data))
  } catch (error) {
    yield put(fromActions.Actions.integrationsSetLoading(false))
    console.log('error: ', error)
  }
}

export function* getIntegrationsWatcherSaga() {
  yield takeLatest(
    fromActions.GENERAL_INTEGRATIONS_LIST,
    getIntegrationsEffectSaga
  )
}
